module.exports = __webpack_public_path__ + "static/media/qp-header@2x.44a2dd57.png";